import { ContextualAlert } from '@ifood/pomodoro-components';
import React, { FC, ReactNode } from 'react';

import { useOpenedByHash } from 'hooks/opened-by-hash';

import { ArrowDown, ArrowUp, Content, HeaderButton } from './styles';

type PropTypes = {
  title: ReactNode;
  id: string;
};

export const Collapse: FC<PropTypes> = ({ title, id, children }) => {
  const [isOpen, handleToggle] = useOpenedByHash(id);

  return (
    <ContextualAlert padding="24px">
      <HeaderButton onClick={handleToggle}>
        {title}
        {isOpen ? <ArrowUp /> : <ArrowDown />}
      </HeaderButton>
      {isOpen && <Content>{children}</Content>}
    </ContextualAlert>
  );
};
